'use client';

import * as React from 'react';
import { createContext, useContext, useMemo, ReactNode } from 'react';
import { WalletOptionsProps } from '../components/ConnectExistingWallet';

interface WalletOptionsProviderProps {
  children: ReactNode;
  walletOption?: WalletOptionsProps | undefined;
}

const WalletOptionsContext = createContext<WalletOptionsProps>({
  enableCrossmint: false,
  enableEmailWallet: true,
  enableMetamask: true,
  enableWalletConnect: true
} as WalletOptionsProps);

export const WalletOptionsProvider = ({ children, walletOption }: WalletOptionsProviderProps) => {
  const defaultWalletOptions = useMemo(
    () => ({
      enableCrossmint: false,
      enableEmailWallet: false,
      enableMetamask: true,
      enableWalletConnect: true
    }),
    []
  );
  const value = useMemo(() => {
    return walletOption
      ? {
          ...defaultWalletOptions,
          ...walletOption
        }
      : defaultWalletOptions;
  }, [walletOption, defaultWalletOptions]);

  return <WalletOptionsContext.Provider value={value}>{children}</WalletOptionsContext.Provider>;
};

export const useWalletOptions = () => useContext<WalletOptionsProps>(WalletOptionsContext);

export default WalletOptionsProvider;
